import { useEffect, useState } from 'react'
import Clock from 'react-clock'
import 'react-clock/dist/Clock.css'
import { useSelector } from 'react-redux'
import harmonySmall from '../../images/harmony-small.jpg'

export default function MediaPending() {
    const { playList } = useSelector(state => state.messages)
    const { playListIndex } = useSelector(state => state.harmonize)
    const { name } = playList[playListIndex]
    const [value, setValue] = useState(new Date())
    const [portrait, setIsPortrait] = useState(window.innerWidth > window.innerHeight ? false : true)

    useEffect(() => {
        const interval = setInterval(() => setValue(new Date()), 1000)
        const handleOrientationChange = () => {
            setIsPortrait(window.screen.orientation.type.startsWith('portrait'))
        }

        window.screen.orientation.addEventListener('change', handleOrientationChange)
        return () => {
            clearInterval(interval)
            window.screen.orientation.removeEventListener('change', handleOrientationChange)
        }
    }, [])

    return (
        <div style={{
            display: 'flex', flexDirection: 'column', width: '100vw', height: '100vh',
            backgroundColor: 'lightblue', justifyContent: 'center', alignItems: 'center',
            paddingLeft: '10vw', paddingRight: '10vw'
        }}>
            <img src={harmonySmall} alt={name} style={{ width: portrait ? '75vw' : '30vw' }} />
            <h4 style={{ textAlign: 'center' }}>The media for {name} is being prepared</h4>
            <div className="Sample__container">
                <main className="Sample__container__content">
                    <Clock size={portrait ? 200 : 150} value={value} />
                </main>
            </div>
        </div>
    )
}